export default __webpack_public_path__ + "static/media/SYS-MATCHIDI-0079.66c7aaeb.pdf";